<div class="table-state">
  @if (isLoading()) {
  <div class="table-state__loading">
    <dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
  </div>
  } @else if (hasData()) {
  <div class="table-state__table">
    <ng-content></ng-content>
  </div>

  <!-- <fdr-past-performance-ui-pagination [totalItems]="totalItems()" /> -->
  } @else {
  <div class="table-state__empty">
    <fdr-past-performance-ui-empty-state 
        [icon]="emptyIcon()"
        [title]="emptyTitle()"
        [subtitle]="emptySubtitle()"
        [emphasized]="true"
  ></fdr-past-performance-ui-empty-state>
  </div>
  }
</div>
